import React from "react";
import { useTranslate } from "@refinedev/core";
import {
  GridFourIcon,
  PlayCircleIcon,
  UserIcon,
  SwatchesIcon,
} from "@phosphor-icons/react";
import { ProjectActionCard } from "./ProjectActionCard";
import { ProjectSectionCard } from "./ProjectSectionCard";
import { AnimationsIcon } from "components/icons";

interface ProjectQuickEditsProps {
  projectId: string;
  projectType: string;
  isLive: boolean;
  storyboardId?: string;
  instanceId?: string;
  mediaId?: string | null;
}

export const ProjectQuickEdits: React.FC<ProjectQuickEditsProps> = ({
  projectId,
  projectType,
  isLive,
  storyboardId,
  instanceId,
  mediaId,
}) => {
  const t = useTranslate();

  const quickEditItems = [
    ...(projectType !== "flash"
      ? [
          {
            key: "storyline",
            icon: <GridFourIcon size="20px" />,
            label: t("media.components.projectQuickEdits.voiceOverScript"),
            route: `/media/projects/${projectId}/${storyboardId}/${instanceId}/script`,
          },
        ]
      : []),
    {
      key: "storyboard",
      icon: <PlayCircleIcon size="20px" />,
      label: t("media.components.projectQuickEdits.storyboard"),
      route: `/media/projects/${projectId}/${storyboardId}/${instanceId}/storyboard/editor`,
    },
    ...(projectType !== "flash"
      ? [
          {
            key: "animated-document",
            route: `/media/projects/${projectId}/media/${mediaId}/animation`,
            icon: <AnimationsIcon />,
            label: t("media.components.ProjectPowerFeatures.animatedDocument"),
          },
        ]
      : []),
    {
      key: "avatar",
      icon: <UserIcon size="20px" />,
      label: t("media.components.projectQuickEdits.avatar"),
      route: `/media/projects/${projectId}/${storyboardId}/${instanceId}/settings/contact`,
    },
    {
      key: "brandkit",
      icon: <SwatchesIcon size="20px" />,
      label: t("media.components.projectQuickEdits.brandkit"),
      route: `/media/projects/${projectId}/${storyboardId}/${instanceId}/settings/brandkit`,
    },
  ];

  return (
    <ProjectSectionCard title={t("media.components.projectQuickEdits.title")}>
      {quickEditItems.map((item) => (
        <ProjectActionCard
          key={item.key}
          route={item.route}
          icon={item.icon}
          label={item.label}
          disabled={isLive}
        />
      ))}
    </ProjectSectionCard>
  );
};
